import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { initGA, logPageView } from "../utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!window.GA_INITIALIZED) {
      initGA();
      window.GA_INITIALIZED = true;
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      logPageView();
    }
  }, [location, initialized]);

  return null;
};

export default AnalyticsTracker;
